import React from 'react';

import ROUTES from '../../../routes';
import { ContentContainer } from '../contentComponents';
import { SectionContainer, SectionHeading } from '../sectionComponents';
import SliderFlex from '../SliderFlex';

const toggles = [
  {
    heading: 'For every role',
    emoji: '💪',
    content:
      'PopSQL is used by data analysts, product managers, customer success, operations, and anyone that wants to write SQL.',
    link: {
      text: 'Learn more',
      href: '/sql-templates/',
      asPath: '/sql-templates/',
    },
  },
  {
    heading: 'Query variables',
    emoji: '✨',
    content:
      'Give business users a way to safely customize queries by using variables, like date ranges or user IDs.',
    link: {
      text: 'Learn more',
      href: '/product/query-variables/',
      asPath: '/product/query-variables/',
    },
  },
  {
    heading: 'See the schema',
    emoji: '📖',
    content: 'Easily see your table structure while writing a query.',
    link: {
      text: 'Learn more',
      href: ROUTES.docsPost('schema').href,
      asPath: ROUTES.docsPost('schema').asPath,
    },
  },
];

const images = [
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/hero/1.svg`,
      style: {
        transform: 'scale(0)',
        borderRadius: '12px',
        boxShadow: 'var(--bs-drop)',
        width: '75%',
        top: 64,
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/fourth-section/1/2.svg`,
      style: {
        transform: 'scale(0)',
        top: 74,
        left: 410,
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/fourth-section/1/3.svg`,
      style: {
        transform: 'scale(0)',
        top: 264,
        left: 124,
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/fourth-section/1/4.svg`,
      style: {
        transform: 'scale(0)',
        top: -74,
        left: 64,
      },
    },
  ],
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/features/variables.svg`,
      style: {
        transform: 'scale(0)',
      },
    },
  ],
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/features/schema.svg`,
      style: {
        transform: 'scale(0)',
      },
    },
  ],
];

const FourthSection = ({ heading }) => {
  return (
    <SectionContainer>
      <SectionHeading text={heading || 'Get the whole team writing SQL'} />
      {/* <SectionSubheading text="Make SQL easier for beginners, experts, and stakeholders alike." /> */}
      <ContentContainer>
        <SliderFlex toggles={toggles} images={images} />
      </ContentContainer>
    </SectionContainer>
  );
};
export default FourthSection;
